import React from 'react';
import { InputProps, StyledInput } from './styles';

export const Input: React.FC<InputProps> = ({ ...rest }: InputProps) => {
  return <StyledInput type="text" {...rest} />;
};
